import { z } from 'zod';

// Flag kinds + severities mirror the CHECK constraints in
// apps/api/schema/0007_brain_consensus.sql. Keep in sync.
export const FLAG_KINDS = [
  'COUNT_DISAGREEMENT', 'UNKNOWN_SYMBOL', 'MISSING_LEGEND_ENTRY',
  'AMBIGUOUS_SCOPE', 'SCOPE_EXCLUSION', 'LOW_CONFIDENCE_DETECTION',
  'PRICING_GAP', 'LABOR_GAP', 'SPEC_CONFLICT', 'COST_CAP_HIT', 'OTHER',
] as const;
export const FlagKindSchema = z.enum(FLAG_KINDS);
export type FlagKind = z.infer<typeof FlagKindSchema>;

export const FLAG_SEVERITIES = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'] as const;
export const FlagSeveritySchema = z.enum(FLAG_SEVERITIES);
export type FlagSeverity = z.infer<typeof FlagSeveritySchema>;

export const FLAG_STATUSES = ['OPEN', 'ANSWERED', 'DISMISSED'] as const;
export const FlagStatusSchema = z.enum(FLAG_STATUSES);
export type FlagStatus = z.infer<typeof FlagStatusSchema>;

// Severity ordering for UI sort. CRITICAL first, LOW last.
export const FLAG_SEVERITY_ORDER: Record<FlagSeverity, number> = {
  CRITICAL: 0,
  HIGH: 1,
  MEDIUM: 2,
  LOW: 3,
};

// Body for POST /projects/:id/flags/:flagId/answer.
export const FlagAnswerSchema = z.object({
  answer: z.string().min(1, 'Answer cannot be empty').max(2000),
});
export type FlagAnswerBody = z.infer<typeof FlagAnswerSchema>;

// Read shape returned to the UI.
export interface FlagListItem {
  id: string;
  project_id: string;
  sheet_id: string | null;
  brain_run_id: string | null;
  kind: FlagKind;
  severity: FlagSeverity;
  title: string;
  question: string;
  ai_assumption: string | null;
  estimated_cost_impact_usd: number | null;
  status: FlagStatus;
  answered_by: string | null;
  answered_at: string | null;
  answer_text: string | null;
  created_at: string;
}
